export const GET_RECORDS = 'GET_RECORDS';
export const GET_SELECTED_RECORD = 'GET_SELECTED_RECORD';
export const GET_LOAD_PARAMS= 'GET_LOAD_PARAMS';